// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/log.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file vitesse/v1/log.proto.
 */
export const file_vitesse_v1_log = /*@__PURE__*/ fileDesc("ChR2aXRlc3NlL3YxL2xvZy5wcm90bxIKdml0ZXNzZS52MSK/AQoITG9nRXZlbnQSFAoMdGltZXN0YW1wX25zGAEgASgDEhAKCHNldmVyaXR5GAIgASgJEg4KBnNvdXJjZRgDIAEoCRIPCgdtZXNzYWdlGAQgASgJEi4KBWF0dHJzGAUgAygLMh8udml0ZXNzZS52MS5Mb2dFdmVudC5BdHRyc0VudHJ5EgwKBGJvZHkYBiABKAkaLAoKQXR0cnNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQq0BCg5jb20udml0ZXNzZS52MUIITG9nUHJvdG9QAVpIZ2l0aHViLmNvbS9Nb3ZlbmRpLWFpL3ZpdGVzc2UtcGxhdGZvcm0vcHJvdG8vZ2VuL2dvL3ZpdGVzc2UvdjE7dml0ZXNzZXYxogIDVlhYqgIKVml0ZXNzZS5WMcoCClZpdGVzc2VcVjHiAhZWaXRlc3NlXFYxXEdQQk1ldGFkYXRh6gILVml0ZXNzZTo6VjFiBnByb3RvMw");
/**
 * Describes the message vitesse.v1.LogEvent.
 * Use `create(LogEventSchema)` to create a new message.
 */
export const LogEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_log, 0);
//# sourceMappingURL=log_pb.js.map